module.exports = __webpack_public_path__ + "img/csr7.5a4906b8.jpg";